<template>
  <div class="col-lg-12 control-section">
    <div class="tree-control-wrapper">
      <ejs-treeview
        ref="RealtimeTaskTree"
        :fields="fields"
        :nodeSelected="nodeSelectedOfMeasureTreeForTask"
      ></ejs-treeview>
    </div>
  </div>
</template>

<script>
import * as dataSource from "./a.json";

class TreeDatas {
  constructor(dataSource) {
    this.dataSource = !!dataSource ? dataSource : [{ children: [] }];
    this.id = 'id';
    this.text = 'text';
    this.child = 'children';
    this.expanded = 'state';
  }
}

export default {
  name: 'RealtimeTaskTree',
  data() {
    return {
      fields: new TreeDatas()
    };
  },
  mounted() {
    this.getMeasureObjUnderTaskTree();
  },
  methods: {
    // 加载树
    getMeasureObjUnderTaskTree() {
      const _this = this;
      this.$axios
        .get('/lte/pm/tree/currenttime/measureObjUnderTask.html?systemId=1')
        .then(response => {
          _this.fields = new TreeDatas(response.data);
        });
    },
    nodeSelectedOfMeasureTreeForTask(args) {
      let counterTypeId = '';
      let measureObjectTypeCode = '';
      let neTypeId = '';
      let attributes = this.$refs.RealtimeTaskTree.getTreeData(
        args.nodeData.id
      )[0].attributes;

      if (attributes) {
        neTypeId = attributes.neTypeId ? attributes.neTypeId : "";
        measureObjectTypeCode = attributes.measureObjectTypeCode
          ? attributes.measureObjectTypeCode
          : '';
        counterTypeId = attributes.counterTypeId
          ? attributes.counterTypeId
          : '';
      }
      const params = {
        measureObjectTypeCode: measureObjectTypeCode,
        counterTypeId: counterTypeId,
        neTypeId: neTypeId,
        treeType: '1'
      };
      this.$emit('transferMeasureObj', params);
    }
  }
};
</script>

<style>
</style>
